export default __webpack_public_path__ + "static/media/mockup11.2cde34e1.jpg";